import { render, staticRenderFns } from "./WameedImageCropperInput.vue?vue&type=template&id=1158ad56&"
import script from "./WameedImageCropperInput.vue?vue&type=script&lang=js&"
export * from "./WameedImageCropperInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports